import { EPeriod, ERoomsCount, IFilters } from 'shared/types/marketTrends';

export const initialState: IFilters = {
  roomsCount: ERoomsCount.All,
  period: EPeriod.All,
};
